import {
	ImageBrowseListingDemo1,
	ImageBrowseListingDemo2,
	ImageBrowseListingDemo3,
	ImageBrowseListingDemo4,
} from "../../assets/BrowseListing/demo";
import type { CartComparisonProperty } from "../../interfaces/comparisonProperty";

export const cartComparisonProperty: CartComparisonProperty[] = [
	{
		city: "Kitchener, ON",
		listingId: "101740668513",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		soldPrice: 450000,
		displayImageUrl: ImageBrowseListingDemo1,
		totalZownSavings: 5000,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Townhouse",
		listPrice: 450000,
		propertyTax: 5000,
		maintenanceFee: 318,
		bedrooms: "2+1",
		bathrooms: 1.5,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "No",
		numberOfParkingSpaces: "1",
		backyard: "Yes",
		pricePerSqft: "693",
		listToSoldRatio: 2,
		dom: 21,
		soldData: "4-30-2024",
		mlsNumber: "C1558446",
		squareFootage: "3420",
		lotSquareFootage: "3420",
		type: "Detached 2-storey",
		rooms: "10+5",
		kitchens: "2",
		familyRoom: "Yes",
		fireplace: "No",
		heatType: "Forced Air",
		heatSource: "Gas",
		ac: "Central Air",
		garage: "Attached",
		driveway: "Available",
		parking: "2",
		pool: "None",
	},
	{
		city: "Kitchener, ON",
		listingId: "101740678756",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		soldPrice: 450000,
		displayImageUrl: ImageBrowseListingDemo2,
		totalZownSavings: 5000,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Townhouse",
		listPrice: 450000,
		propertyTax: 5000,
		maintenanceFee: 318,
		bedrooms: "2+1",
		bathrooms: 1.5,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "Yes - Unfinished",
		numberOfParkingSpaces: "1",
		backyard: "Yes",
		pricePerSqft: "693",
		listToSoldRatio: 2,
		dom: 21,
		soldData: "4-30-2024",
		mlsNumber: "C5558446",
		squareFootage: "3420",
		lotSquareFootage: "3420",
		type: "Detached 2-storey",
		rooms: "10+5",
		kitchens: "2",
		familyRoom: "Yes",
		fireplace: "No",
		heatType: "Forced Air",
		heatSource: "Gas",
		ac: "Central Air",
		garage: "Attached",
		driveway: "Available",
		parking: "2",
		pool: "None",
	},
	{
		city: "Kitchener, ON",
		listingId: "1002E10428917",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		soldPrice: 450000,
		displayImageUrl: ImageBrowseListingDemo3,
		totalZownSavings: 5000,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Apartment",
		listPrice: 450000,
		propertyTax: 5000,
		maintenanceFee: 318,
		bedrooms: "2",
		bathrooms: 1,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "No",
		numberOfParkingSpaces: "1",
		backyard: "Yes",
		pricePerSqft: "693",
		listToSoldRatio: 1,
		dom: 10,
		soldData: "4-30-2024",
		mlsNumber: "C1558416",
		squareFootage: "3420",
		lotSquareFootage: "3420",
		type: "Detached 2-storey",
		rooms: "10+5",
		kitchens: "2",
		familyRoom: "Yes",
		fireplace: "No",
		heatType: "Forced Air",
		heatSource: "Gas",
		ac: "Central Air",
		garage: "Attached",
		driveway: "Available",
		parking: "2",
		pool: "None",
	},
	{
		city: "Kitchener, ON",
		listingId: "4",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		soldPrice: 450000,
		displayImageUrl: ImageBrowseListingDemo4,
		totalZownSavings: 5200,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Apartment",
		listPrice: 840000,
		propertyTax: 2000,
		maintenanceFee: 318,
		bedrooms: "2",
		bathrooms: 1,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "No",
		numberOfParkingSpaces: "1",
		backyard: "No",
		pricePerSqft: "693",
		listToSoldRatio: 1,
		dom: 10,
		soldData: "4-30-2024",
		mlsNumber: "C1558300",
		squareFootage: "3420",
		lotSquareFootage: "3420",
		type: "Detached 2-storey",
		rooms: "10+5",
		kitchens: "2",
		familyRoom: "Yes",
		fireplace: "No",
		heatType: "Forced Air",
		heatSource: "Gas",
		ac: "Central Air",
		garage: "Attached",
		driveway: "Available",
		parking: "2",
		pool: "None",
	},
	{
		city: "Kitchener, ON",
		listingId: "5",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		soldPrice: 450000,
		displayImageUrl: ImageBrowseListingDemo3,
		totalZownSavings: 5200,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Apartment",
		listPrice: 840000,
		propertyTax: 2000,
		maintenanceFee: 318,
		bedrooms: "2",
		bathrooms: 1,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "No",
		numberOfParkingSpaces: "1",
		backyard: "No",
		pricePerSqft: "693",
		listToSoldRatio: 1,
		dom: 10,
		soldData: "4-30-2024",
		mlsNumber: "C1558300",
		squareFootage: "3420",
		lotSquareFootage: "3420",
		type: "Detached 2-storey",
		rooms: "10+5",
		kitchens: "2",
		familyRoom: "Yes",
		fireplace: "No",
		heatType: "Forced Air",
		heatSource: "Gas",
		ac: "Central Air",
		garage: "Attached",
		driveway: "Available",
		parking: "2",
		pool: "None",
	},
];

export const fieldTitles: { [key: string]: string } = {
	city: "City",
	propertyType: "Property Type",
	bedrooms: "Bedrooms",
	mlsNumber: "MLS ID",
	listPrice: "List Price",
	soldPrice: "Sold Price",
	soldDate: "Sold Date",
	propertyTax: "Property Tax",
	maintenanceFee: "Maintenance Fee",
	bathrooms: "Bathrooms",
	squareFootage: "Square Footage",
	lotSquareFootage: "Lot Square Footage",
	basement: "Basement",
	numberOfParkingSpaces: "Parking",
	backyard: "Backyard",
	pricePerSqft: "Price per SQFT",
	dom: "Dom",
	openHouseDate: "Open House Date",
	listToSoldRatio: "List to Sold Ratio",
	type: "Type",
	rooms: "Rooms",
	kitchens: "Kitchens",
	familyRoom: "Family Room",
	fireplace: "Fireplace",
	heatType: "Heat Type",
	heatSource: "Heat Source",
	ac: "A/C",
	garage: "Garage",
	driveway: "Driveway",
	parking: "Parking",
	pool: "Pool",
};

export const sections = [
	{
		title: "QuickFacts",
		fields: [
			"city",
			"propertyType",
			"bedrooms",
			"bathrooms",
			"squareFootage",
			"dom",
			"listPrice",
			"soldPrice",
			"soldDate",
		],
	},
	{
		title: "Details",
		fields: [
			"type",
			"lotSquareFootage",
			"basement",
			"maintenanceFee",
			"propertyTax",
			"rooms",
			"kitchens",
			"familyRoom",
			"fireplace",
			"heatType",
			"heatSource",
			"ac",
			"garage",
			"driveway",
			"parking",
			"pool",
		],
	},
];
